import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=5d3d0eca&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=ts"
export * from "./PersonalData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d0eca",
  null
  
)

export default component.exports